<!-- Mobile Toggle -->
<div class="md:hidden mb-4">
    <button class="flex items-center gap-2 bg-surface-2 text-white rounded-lg px-4 py-2 text-sm" (click)="manuallyExpanded = !manuallyExpanded">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
        </svg>
        {{ 'filter.filters' | translate }}
    </button>
</div>

<!-- Sidebar Filters -->
<div class="bg-surface-2 rounded-lg pt-6 pb-6 px-5 h-full min-h-[500px]"
     [ngClass]="{'block': filtersExpanded, 'hidden md:block': !filtersExpanded}">
    <div class="flex flex-col gap-6" *ngIf="facets?.length; else noFilters">
        <div *ngFor="let facet of facets; trackBy:trackById">
            <!-- Facet Header -->
            <div class="flex items-center justify-between cursor-pointer" (click)="facet._expanded = !facet._expanded">
                <span class="text-white text-sm">{{ facet.name }}</span>
                <svg class="w-4 h-4 text-white transition-transform" [class.rotate-45]="facet._expanded" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
            </div>
            <!-- Facet Values -->
            <div *ngIf="facet._expanded" class="mt-4 flex flex-col gap-4 pl-4">
                <label *ngFor="let value of facet.values; trackBy:trackById"
                       class="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox"
                           [checked]="isActive(value.id)"
                           (change)="toggleFacetValueIdInRoute(value.id)"
                           class="w-4 h-4 rounded border-white bg-surface-2 text-primary focus:ring-primary focus:ring-offset-0">
                    <span class="text-white text-sm">{{ value.name }}</span>
                </label>
            </div>
        </div>
    </div>
    <ng-template #noFilters>
        <div class="flex flex-col items-center justify-center gap-3 py-16 text-center">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
            <span class="text-gray-400 text-sm">{{ 'filter.noFilters' | translate }}</span>
        </div>
    </ng-template>
</div>
